import script from "./MonthlyCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthlyCalendar.vue?vue&type=script&setup=true&lang=js"

import "./MonthlyCalendar.vue?vue&type=style&index=0&id=61601004&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61601004"]])

export default __exports__